export function getIndividualPackageName(hours: number): string {
  if (hours <= 1) return 'Express';
  if (hours <= 2) return 'Standard';
  return 'Extended';
}

/**
 * Express (1h) can only be booked as a Last-Minute slot: the backend offers 1h appointments
 * only for sessions starting within the next 24h (BookingPolicy.LastMinuteWindowHours).
 */
export function isLastMinuteOnlyPackage(hours: number): boolean {
  return hours <= 1;
}
